import { useEffect, useRef } from "react";
import { PrivateMessage } from "../types/PrivateChat";
import PrivateMessageBubble from "./PrivateMessageBubble";

interface Props {
    messages: PrivateMessage[];
}

const PrivateMessageList = ({ messages }: Props) => {

    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        requestAnimationFrame(() => {
            if (containerRef.current) {
                containerRef.current.scrollTop =
                    containerRef.current.scrollHeight;
            }
        });
    }, [messages]);

    return (
<div
    ref={containerRef}
    className="d-flex flex-column p-3"
    style={{
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden"
    }}
>
    {messages.map(message => (
        <PrivateMessageBubble
            key={message.privateMessageId}
            message={message}
        />
    ))}
</div>
    );
};

export default PrivateMessageList;